// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.selectLabel[data-v-7f05d8ce] {\n  height: 28px !important;\n  line-height: 28px !important;\n}\n.pagination[data-v-7f05d8ce] {\n  text-align: right;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
